import _ from 'lodash';
import {
  ADD_REFRESHING_FUNC,
  CALL_REFRESHING_FUNC,
  REMOVE_REFRESHING_FUNC,
  START_REFRESHING,
  END_REFRESHING,
  REFRESH_NEW_SR,
} from '../types';

import actions from '../../state/actions';

const refreshingFunctions = {};

const addRefreshFunction = function addRefreshFunction(key, func) {
  return (dispatch) => {
    refreshingFunctions[key] = func;
    dispatch({
      type: ADD_REFRESHING_FUNC,
      payload: {
        key,
      },
    });
  };
};

const removeRefreshFunction = function removeRefreshFunction(key) {
  return (dispatch) => {
    if (_.has(refreshingFunctions, key)) {
      delete refreshingFunctions[key];
    }
    dispatch({
      type: REMOVE_REFRESHING_FUNC,
      payload: {
        key,
      },
    });
  };
};

const getFilterByPath = (pathname, filter) => {
  let filterName = '';
  let action = '';

  switch (pathname) {
    case '/access/rooms':
      filterName = 'locations';
      action = 'filterLocations';
      break;
    case '/access/workorders':
      filterName = 'workordersList';
      action = 'filterWorkorder';
      break;
    case '/access/requests':
      filterName = 'serviceRequests';
      action = 'filterRequest';
      break;
    default:
      console.error(`No filter path handler for pathname: ${pathname}!`);
      break;
  }

  return {
    filter: filter[filterName],
    action: actions[action],
  };
};

const refreshComplete = function refreshComplete() {
  return (dispatch, getState) => {
    const {
      refresh: {
        refreshing,
      },
      filter,
      routing: {
        locationBeforeTransitions: {
          pathname,
        },
      },
    } = getState();
    if (refreshing === true) {
      dispatch({
        type: END_REFRESHING,
      });

      // Sort & filter in case if it is set
      if (pathname && filter) {
        // Filter & sort right after refresh
        const filterByPath = getFilterByPath(pathname, filter);

        if (filterByPath.filter && filterByPath.action) {
          const filterKey = filterByPath.filter.filterKey;
          const sortKey = filterByPath.filter.sortKey;
          const filterAction = filterByPath.action;

          dispatch(filterAction(filterKey, sortKey));
        }
      }
    }
  };
};

const refreshAction = function refreshAction(isManual) {
  return (dispatch) => {
    dispatch({
      type: START_REFRESHING,
    });
    if (Object.keys(refreshingFunctions).length > 0) {
      Object.keys(refreshingFunctions).forEach((key) => {
        dispatch({
          type: CALL_REFRESHING_FUNC,
          payload: {
            key,
          },
        });
        refreshingFunctions[key](isManual);
      });
    } else {
      window.setTimeout(() => {
        dispatch(refreshComplete());
      }, 50);
    }
  };
};

const refreshNewSrAction = function refreshNewSrAction() {
  return (dispatch) => {
    dispatch({
      type: REFRESH_NEW_SR,
    });
  };
};

export default {
  addRefreshFunction,
  removeRefreshFunction,
  refreshComplete,
  refreshAction,
  refreshNewSrAction,
};



// WEBPACK FOOTER //
// ./src/state/actions/refresh.js